"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.XyriasLinkAbilityHandler = exports.XyriasLinkActorAbilityFactory = exports.XyriasLinkAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const __1 = require("../..");
const Duration_1 = require("../../core/Duration");
class XyriasLinkAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.XyriasLink;
        this.__typeName = "XyriasLink";
    }
}
exports.XyriasLinkAbilityArgs = XyriasLinkAbilityArgs;
let XyriasLinkActorAbilityFactory = class XyriasLinkActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("XyriasLink", "AllEnemies", 0);
    }
};
XyriasLinkActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("XyriasLink")
], XyriasLinkActorAbilityFactory);
exports.XyriasLinkActorAbilityFactory = XyriasLinkActorAbilityFactory;
let XyriasLinkAbilityHandler = class XyriasLinkAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const enemies = ability.args.target.actorIds;
        container.applyBuff({
            sequence,
            creatorId: ability.invokerId,
            targetId: ability.invokerId,
            effect: new __1.SplitDamageReflectEffectArgs(ability.invokerId, enemies),
            duration: Duration_1.Duration.Turns(4),
        });
    }
};
XyriasLinkAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.XyriasLink)
], XyriasLinkAbilityHandler);
exports.XyriasLinkAbilityHandler = XyriasLinkAbilityHandler;
